import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  keywords?: string;
}

function setMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
}